// Shop info — replace placeholders later
export const SITE = {
  name: "Monarch Cutz",
  tagline: "The Throne Is Waiting",
  phone: "800-281-2717",
  phoneHref: "tel:+18002812717",
  email: "info@monarchcutz.com",
  adminEmail: "info@monarchcutz.com",
  address: "107 E 9th St, Los Angeles, CA 90015",
  hours: [
    { day: "Daily", time: "9:00 AM – 7:00 PM" },
  ],
  social: {
    instagram: { handle: "@monarch_cutz", url: "https://instagram.com/monarch_cutz" },
    facebook: { handle: "Monarch Cutz", url: "https://facebook.com/monarchcutz" },
    tiktok: { handle: "@monarch.cutz", url: "https://tiktok.com/@monarch.cutz" },
    reddit: { handle: "r/LosAngeles", url: "https://www.reddit.com/r/LosAngeles/search/?q=monarch+cutz" },
  },
  reviews: {
    placeId: "ChIJIdniEMvHwoAR-ITuKhTtrQM",
    google: "https://search.google.com/local/writereview?placeid=ChIJIdniEMvHwoAR-ITuKhTtrQM",
    viewOnGoogle: "https://www.google.com/maps/place/?q=place_id:ChIJIdniEMvHwoAR-ITuKhTtrQM",
    googleEmbed: "https://www.google.com/maps/embed/v1/place?key=&q=place_id:ChIJIdniEMvHwoAR-ITuKhTtrQM",
    // Fallback embed without API key (uses q=address)
    googleEmbedNoKey: "https://www.google.com/maps?q=place_id:ChIJIdniEMvHwoAR-ITuKhTtrQM&output=embed",
  },
};

export const TIME_SLOTS = [
  "09:00", "09:30", "10:00", "10:30",
  "11:00", "11:30", "12:00", "12:30",
  "13:00", "13:30", "14:00", "14:30",
  "15:00", "15:30", "16:00", "16:30",
  "17:00", "17:30", "18:00", "18:30",
];
